import candidates from './modules/candidates';
import clients from './modules/clients';
import tasks from './modules/tasks';

export default [candidates, clients, tasks];
